import React from 'react';
import PropTypes from 'prop-types';

import Contact from './Contact';

const PressContacts = ({
  pressContacts,
}) => {
  const contacts = pressContacts.map((contact) => (
    <Contact
      key={contact.name}
      email={contact.email}
      name={contact.name}
      phone_number={contact.phone_number}
    />
  ));

  return (
    <>
      <div className="content__contacts-header">Press Contacts</div>
      {contacts}
    </>
  );
};

PressContacts.propTypes = {
  pressContacts: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      phone_number: PropTypes.string,
    }),
  ).isRequired,
};

export default PressContacts;
